export default "__VITE_ASSET__0740fa77__"